// Setup › Templates at `/c/{slug}/setup/templates` (M1-06; core, managers, like Setup › Seats).
// The open template is in the URL (`?template=`), next to the focus keys.
import { createRoute, useNavigate } from "@tanstack/react-router";
import { TemplatesScreen } from "../features/structure/templates-screen";
import { useCompany } from "../features/use-feature";
import { keepFocus, validateFocusSearch } from "../focus/focus";
import { setupRoute } from "./c.$slug.setup";

const ID = /^[0-9a-f-]{36}$/i;

export const setupTemplatesRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "templates",
  validateSearch: (search: Record<string, unknown>) => ({
    ...validateFocusSearch(search),
    ...(typeof search.template === "string" && ID.test(search.template)
      ? { template: search.template }
      : {}),
  }),
  component: function Templates() {
    const { api } = setupTemplatesRoute.useRouteContext();
    const { template } = setupTemplatesRoute.useSearch();
    const company = useCompany();
    const navigate = useNavigate();
    return (
      <TemplatesScreen
        api={api}
        company={company}
        templateId={template}
        onTemplate={(id) =>
          void navigate({
            to: ".",
            search: (prev: Record<string, unknown>) => {
              const { template: _drop, ...rest } = prev;
              return id ? { ...rest, template: id } : rest;
            },
          } as never)
        }
        onOpenSeats={() =>
          void navigate({
            to: "/c/$slug/setup/seats",
            params: { slug: company.slug },
            search: keepFocus as never,
          })
        }
      />
    );
  },
});
